module.exports = __webpack_public_path__ + "static/media/VirtualGateway.46411177.md";